export const CLIENT_ID = 'AZ0ULzwFW7aK5gQQMILxYKm14BFf5JeG11DKCID39PvOvOUYnKNK-doXK-ISh0bPftLh5jxXfyFTJ6_q'
//This file must be replaced in production and the variable should be used in react environment